module.exports = __webpack_public_path__ + "img/left-arrow.f9641fbc.svg";